import { Box } from "@chakra-ui/react";
import GenericFailureDialog from "src/components/GenericFailureDialog";
import NavigationBar from "src/components/NavigationBar";
import LullabyPlayerView from "./LullabyPlayerView";

export default function LullabyPlayer({
  openLullabies,
  onClose,
  defaultLullaby,
  otherLullabies,
  lullabyPlayer
}) {
  return (
    <>
      <GenericFailureDialog
        isOpen={lullabyPlayer.hasError}
        onDismiss={lullabyPlayer.clearError}
      />
      <NavigationBar
        headingKey="lullabies"
        onClose={onClose}
        actionButton={{
          onClick: openLullabies,
          labelKey: "lullaby.manageHeader"
        }}
      />
      <Box height="calc(100% - 61px)" p="24px">
        <LullabyPlayerView
          lullabyPlayer={lullabyPlayer}
          otherLullabies={otherLullabies}
          defaultLullaby={defaultLullaby}
        />
      </Box>
    </>
  );
}
